import { Theme, createTheme } from '@mui/material';
import { useEffect, useState } from 'react';

import { PaletteAsset } from '../../content/models/PaletteAsset';
import { isEqual } from 'lodash';
import useThemes from './useThemes';

const useLessonColorTheme = (palette: PaletteAsset) => {
  const { muiTheme } = useThemes();
  const muiPrimary = muiTheme.palette.primary;
  const muiSecondary = muiTheme.palette.secondary;
  const [lessonColorTheme, setLessonColorTheme] = useState<Theme>(muiTheme);

  useEffect(() => {
    const theme = createTheme({
      ...muiTheme,
      palette: {
        primary: {
          main: palette?.main || muiPrimary.main,
          contrastText: palette?.contrastText || muiPrimary.contrastText,
          dark: palette?.dark || muiPrimary.dark
        },
        secondary: {
          main: palette?.main || muiSecondary.main,
          contrastText: palette?.contrastText || muiSecondary.contrastText,
          dark: palette?.dark || muiSecondary.dark
        }
      }
    });
    setLessonColorTheme((curr) => (isEqual(curr, theme) ? curr : theme));
  }, [muiTheme, palette]);

  return {
    lessonColorTheme
  };
};
export default useLessonColorTheme;
